
import "bootstrap/dist/css/bootstrap.min.css";
import * as React from 'react';
import * as rsuite from 'rsuite';
import Layout from '../../Layout/InnerLayout.js';
import * as General from '../General/General.js';
import { isMobile, isBrowser } from 'react-device-detect';
import { useNavigate } from 'react-router-dom';
import * as BiIcon from "react-icons/bi";
import { Helmet } from "react-helmet";


const ProductGroup = () => {

    //#region Const 
    const navigate = useNavigate();
    const [ProductGroupList, setProductGroupList] = React.useState([]);
    const [background, setbackground] = React.useState("../assets/Images/COM_TOPKV_PC_img05.jpg");





    const GetProductGroup = () => {
        fetch(General.ApiRoute() + '/ProductGroup/SearchForWeb', {
            method: 'Get',
            headers: {
                'ApiKey': General.APIKey(),
                'WebIsActive': 1,
                'IsActive': -1
            },
            credentials: 'include'
        })
            .then(res => res.json())
            .then(result => {
                var tmp = []
                for (var i = 0; i < result.length; i++) {

                    tmp.push({
                        id: result[i].id,
                        title: result[i].title,
                        isActive: result[i].isActive,
                        webIsActive: result[i].webIsActive,
                        parentId: result[i].parentId,
                        identityNo: result[i].identityNo,
                        children: result[i].children,
                        photoTag: result[i].photoTag,
                        PhotoUrl: General.ApiPhotoRoute() + 'Content/Images/Product/Group/' + result[i].photoTag + '' + result[i].photoId + '_Img.jpg',


                    })
                }

                setProductGroupList(tmp)
            })
    }

    const ShowProduct = (id, parentId, Parenttitle, title) => {

        var parent = General.toSlug(Parenttitle, { latin: true });
        var group = General.toSlug(title, { latin: true });
        var NewGroup = group != parent ? group.replace(parent, "").replace(/-+/g, "-").replace(/^-+|-+$/g, "") : group;
        navigate('/Product/' + parent + "/" + NewGroup + "/" + parentId + "/" + id)

    }
    const ShowGroup = (id, title) => {
        var group = General.toSlug(title, { latin: true });

        navigate('/Group/' + group + "/" + id)

    }


    //#endregion
    React.useEffect(() => {
        GetProductGroup();
        localStorage.removeItem("ByBrand");
        localStorage.removeItem("ProductId");

        document.title = "دسته بندی محصولات";
    }, [])


    return (
        <Layout>
            <Helmet>
                <title>فروشگاه فارم آسان | تجهیزات کشاورزی و صنعتی</title>
                <meta
                    name="description"
                    content="بازرگانی فارم آسان؛ عرضه‌کننده انواع تجهیزات کشاورزی، موتور برق، پمپ، کارواش، سمپاش و ابزار صنعتی در شیراز."
                />
            </Helmet >
            <div className={isBrowser ? 'InnerBanner' : "InnerBanner_MobView"}
                // className={styles.article}

                style={{
                    backgroundImage: `url(${background})`
                    // , background: `linear-gradient(90deg, rgba(47,72,88,1) 0%, rgba(76,114,139,1) 27%, rgba(251,250,250,1) 67%)`
                }}
            >
            </div>
            <h1 className={isBrowser ? "InnerBanner-text " : "InnerBanner-text_MobView"}>دسته بندی محصولات
                <div className={isBrowser ? "InnerBanner-sub-title" : 'hide'}>Product Category </div>
            </h1>
            <h1 className="ProductInfoAddressBar ">
                <rsuite.Breadcrumb>
                    <rsuite.Breadcrumb.Item href="/">
                        خانه
                    </rsuite.Breadcrumb.Item>

                    <rsuite.Breadcrumb.Item style={{ color: '#3b6682' }}>دسته بندی محصولات</rsuite.Breadcrumb.Item>
                </rsuite.Breadcrumb>
            </h1>
            <rsuite.Grid className="pt-3">



                <rsuite.Row className="justify-content-center align-items-center pt-5">

                    {ProductGroupList.map(group => (

                        <rsuite.Col xs={12} sm={12} md={8} lg={6} className="pb-4">
                            <rsuite.Panel className='shadow-sm  ' onDoubleClick={() => ShowGroup(group.id, group.title)} bodyFill style={{ display: 'inline-block', width: isMobile ? 150 : 200 }}>


                                <rsuite.Image
                                    src={group.PhotoUrl}
                                    fallbackSrc="../../assets/images/ProductGroupPrefer.jpg"
                                    alt={group.title}
                                    placeholder={<img src="../../assets/images/Bars@1x-1.0s-200px-200px.gif" style={{ width: '100%', height: '180px' }} />}
                                    zoomed

                                    style={{ width: '100%', height: '180px' }}
                                />

                                <rsuite.Panel className='fw-bold Cursor'>
                                    <rsuite.Whisper placement="autoVerticalStart" trigger={(['click'])} speaker={
                                        <rsuite.Popover full className='PopoverMenu ' >
                                            <rsuite.Dropdown.Menu className='w-100'>
                                                {group.children.map(chid =>
                                                    <rsuite.Dropdown.Item onClick={() => ShowProduct(chid.id, group.id, group.title, chid.title)}>{chid.title}</rsuite.Dropdown.Item>
                                                )}

                                            </rsuite.Dropdown.Menu>
                                        </rsuite.Popover>
                                    }>

                                        <p className="text-truncate"> <BiIcon.BiCaretDown />  {group.title} </p>


                                    </rsuite.Whisper>




                                </rsuite.Panel>
                            </rsuite.Panel>

                        </rsuite.Col>
                    ))}
                </rsuite.Row>
            </rsuite.Grid>


        </Layout >
    )
}

export default ProductGroup;